import React, { useContext, useRef, useEffect } from 'react';
import { Attribute, IPdpData } from '../types/PDP';
import { convertCamelCaseToTitle, scrollToFitAndDescription } from '../utils';
import BraGuide from './ProductBraGuide';
import WarmthGuide from './ProductWarmthGuide';
import TestedAndApproved from './TestedAndApproved';
import { ProductContext } from '../ProductContext';
import DetailsAccordion from './DetailsAccordion';
import { marked } from 'marked';

const ProductInfoMobile = ({
  pdpData,
  apparelAttribs,
  beautyAttribs,
}: {
  pdpData: IPdpData;
  apparelAttribs: Attribute[];
  beautyAttribs: Attribute[];
}) => {
  const { descriptionHtml } = pdpData.pdpProductShell;
  const { isAccordionCollapsed, setFitAndDescriptionView } = useContext(ProductContext);
  const accordionWrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (accordionWrapperRef.current && isAccordionCollapsed) {
      scrollToFitAndDescription(accordionWrapperRef.current);
      setFitAndDescriptionView(false);
    }
  }, [isAccordionCollapsed, setFitAndDescriptionView]);

  return (
    <div className="accordion__wrapper" ref={accordionWrapperRef}>
      <DetailsAccordion description="Description">
        <div className={'product-accordion-data'} dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
        {beautyAttribs[0] ? <TestedAndApproved attribute={beautyAttribs[0]} /> : null}
        <BraGuide tags={pdpData.pdpProductShell.tags} productType={pdpData.products[0].productType} />
        <WarmthGuide tags={pdpData.pdpProductShell.tags} />
      </DetailsAccordion>
      {apparelAttribs.map(({ label, value }) => (
        <DetailsAccordion description={convertCamelCaseToTitle(label)}>
          <div className={'product-accordion-data'}>
            {value && (
              <ul>
                {value.split(/\r?\n/).map((text, idx) => (
                  <li key={idx} dangerouslySetInnerHTML={{ __html: marked(text) }} />
                ))}
              </ul>
            )}
          </div>
        </DetailsAccordion>
      ))}
    </div>
  );
};

export default React.memo(ProductInfoMobile);
